import request from '@/router/axios'

export const getList = (params) => {
  return request({
    url: '/api/produce/base-device-person-in-charge/select/page',
    method: 'post',
    params,
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-device-person-in-charge/select/id',
    method: 'get',
    params: {
      id,
    },
  })
}

export const add = (row) => {
  return request({
    url: '/api/produce/base-device-person-in-charge/insert',
    method: 'post',
    data: row,
  })
}

export const update = (row) => {
  return request({
    url: '/api/produce/base-device-person-in-charge/update',
    method: 'post',
    data: row,
  })
}

export const remove = (id) => {
  return request({
    url: '/api/produce/base-device-person-in-charge/delete/id',
    method: 'get',
    params: {
      id,
    },
  })
}
